import { render } from "./checkContent.vue?vue&type=template&id=304f0e81&scoped=true&ts=true"
import script from "./checkContent.vue?vue&type=script&lang=ts"
export * from "./checkContent.vue?vue&type=script&lang=ts"

import "./checkContent.vue?vue&type=style&index=0&id=304f0e81&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304f0e81"]])

export default __exports__